import { RESERVED_AGENCY_SLUG_LIST } from '@saaga/shared/constants/agency.constants'
import { SLUG_PATTERN } from '@saaga/shared/utils/slug.util'
import { z } from 'zod'

export const agencyCategoryList = [
  'marketing',
  'development',
  'analytics',
  'support',
  'sales',
  'content',
  'automation',
  'research',
] as const

export const agencyFormSchema = z.object({
  slug: z
    .string()
    .min(1, 'Slug is required')
    .max(100, 'Slug must be at most 100 characters')
    .regex(SLUG_PATTERN, 'Slug must contain only lowercase letters, numbers, and hyphens')
    .refine(
      (val) =>
        !RESERVED_AGENCY_SLUG_LIST.includes(val as (typeof RESERVED_AGENCY_SLUG_LIST)[number]),
      'This slug is reserved and cannot be used'
    ),
  name: z
    .string()
    .min(1, 'Agency name is required')
    .max(200, 'Agency name must be at most 200 characters'),
  logoUrl: z.string().nullable(),
  shortDescription: z.string().optional(),
  longDescription: z.string().optional(),
  systemPrompt: z.string().optional(),
  bestFor: z.string().max(500, 'Best for field must be at most 500 characters').optional(),
  categoryList: z.array(z.enum(agencyCategoryList)).optional(),
  visibility: z.enum(['draft', 'private', 'pending_review', 'public', 'rejected']),
  version: z.number().int().positive(),
})

export type AgencyFormSchemaType = z.infer<typeof agencyFormSchema>

export const defaultAgencyFormValues: AgencyFormSchemaType = {
  slug: '',
  name: '',
  logoUrl: null,
  shortDescription: '',
  longDescription: '',
  systemPrompt: '',
  bestFor: '',
  categoryList: [],
  visibility: 'draft',
  version: 1,
}
